import React from 'react';
import {Snackbar, withStyles} from '@material-ui/core';
import {styles} from './styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import {Props} from './type';

const divStyle = {
    display: 'flex',
    alignItems: 'center'
};

const Notification = ({
    stateSuccess = false,
    stateError = false,
    closeNotification,
    textSuccess,
    textError,
    classes
}: Props) => {
    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                open={stateSuccess}
                autoHideDuration={3000}
                onClose={closeNotification}
                ContentProps={{
                    classes: {
                        root: classes.success
                    }
                }}
                message={
                    <div style={divStyle}>
                        <span style={{marginRight: '10px', display: 'flex'}}><CheckCircleIcon/></span>
                        {textSuccess}
                    </div>}
            />
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                open={stateError}
                autoHideDuration={3000}
                onClose={closeNotification}
                ContentProps={{
                    classes: {
                        root: classes.error
                    }
                }}
                message={
                    <div style={divStyle}>
                        <span style={{marginRight: '10px', display: 'flex'}}><ErrorIcon/></span>
                        {textError}
                    </div>}
            />
        </>
    );
};

export default withStyles(styles)(Notification);
